import React from "react";
import styled from "styled-components";
import { breakpoints } from "../styles";
import { EcgDiag } from "./EcgDiag";

interface EcgSignal {
    time: number;
    value: number;
}

export const EcgViz = (props: {
    patientEcg: number[][];
    prediction: number[];
}) => {
    const CATEGORIES = 4;
    const LEADS = 12;

    const symptomMap = [
        [1, 7, 11], // 1daVB
        [6, 11], // RBBB
        [6, 11], // LBBB
        [1], // SB
        [1, 2], // AF
        [1], // ST
        [], // Normal
    ];

    let ecg = props.patientEcg;
    let ecg_diag_titles = [
        "I",
        "II",
        "III",
        "aVF",
        "aVR",
        "aVL",
        "V1",
        "V2",
        "V3",
        "V4",
        "V5",
        "V6",
    ];

    let colors = Array(12).fill("white");

    props.prediction.forEach((pred, index) => {
        let symptoms = symptomMap[index];
        let predPerc = pred * 100;
        symptoms.forEach((graph) => {
            if (predPerc >= 75) colors[graph] = "red";
            else if (predPerc >= 40 && colors[graph] === "white")
                colors[graph] = "yellow";
            else if (predPerc >= 10 && colors[graph] === "white")
                colors[graph] = "#43DAFF";
        });
    });

    return (
        <Container>
            {ecg.map((_, i) => (
                <EcgDiag
                    ecg={ecg[i]}
                    title={ecg_diag_titles[i]}
                    color={colors[i]}
                />
            ))}
        </Container>
    );
};

const Container = styled.div`
    flex: 1;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-auto-rows: minmax(min-content, max-content);
    gap: 2%;

    // ECG graphs bug out on mobile, so currently we hide it
    // TODO: fix graphs to display on mobile
    @media ${breakpoints.md} {
        width: 0;
        height: 0;
    }
`;
